import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import RestService from "./../../Restservice";
import Loader from "./../../component/Loader";
import GlobalHelmet from "./../../GlobalHelmet";
import Common from "./../../common.json";
import Breadcrumbs from "./../../component/breadcrumbs";
import { makeStyles } from "@material-ui/core/styles";
import FIIDIIFaqs from "./FIIDIIFaqs";
const useStyles = makeStyles({
  root: {
    minWidth: 275,
  },
});

export default function FIIDII() {
  let mobile = "";
  let web_token = "";
  const userdata = localStorage.getItem("userdata")
    ? JSON.parse(localStorage.getItem("userdata"))
    : "";
  mobile = userdata.mobile ? userdata.mobile : "";
  web_token = userdata.web_token ? userdata.web_token : "";
  const classes = useStyles();
  const [loading, setLoading] = useState(false);
  const [column, setcolumn] = useState(1);
  const [getRec, setgetRec] = useState(false);

  const [paramone, setparamone] = useState(3);
  const [paramtwo, setparamtwo] = useState(1);
  let temp = 1;
  function refreshPage() {
    var d = new Date();
    var n = d.getTime();
    setcolumn(n);
  }

  useEffect(() => {
    setLoading(true);
    RestService.getFIIDIIIList(
      function (res) {
        setLoading(false);
        const response = JSON.parse(res);
        setgetRec(response.data.getRec);
      },
      mobile,
      web_token,
      paramone,
      paramtwo
    );
  }, [column, mobile, web_token, paramone, paramtwo]);

  const handleparamone = (event, paramsone) => {
    setparamone(paramsone);
    var d = new Date();
    var n = d.getTime();
    setcolumn(n);
  };
  const handleparamtwo = (event, paramstwo) => {
    setparamtwo(paramstwo);
    var d = new Date();
    var n = d.getTime();
    setcolumn(n);
  };
  return (
    <>
      <GlobalHelmet {...Common?.fiiDii} />
      {loading ? <Loader /> : ""}
      <div className="bodycontainer">
        <div className="auto-space">
          <div className="row">
            <div className="col-sm-12">
              <div className="fixedAddButton">
                <button
                  className="btn btn-success mr-1"
                  title="Reload Page"
                  onClick={refreshPage}
                >
                  <i className="fa fa-refresh"></i>
                </button>
                <Link
                  className="btn btn-success"
                  to="/stock-market-today"
                >
                  <i className="fa fa-arrow-left"></i>{" "}
                </Link>
              </div>
              <Breadcrumbs page="FII DII" />
              <h1 className="highlighttext"> FII DII</h1>
              <p>
              Get FII DII activities for cash & future market. Analyze future and options for stocks & index options daily. Analyze daily, weekly & monthly FII DII activities for better market direction. Explore fii dii data today with nifty and bank nifty percentage change and find clues for market direction. Find historical data for fii dii data and find your secret by analyzing nifty and bank nifty gain or loss.
              </p>

              <div className={classes.root}>
                <div className="">
                  <div className="row">
                    <div className="col-md-12">
                      <div className="tabelcontiner">
                        <div className="row edit-columns">
                          <div className="col-md-6 btn-sec">
                            <button
                              onClick={(event) => handleparamone(event, 3)}
                              className={
                                paramone === 3
                                  ? "btn btn-success"
                                  : "btn btn-secondary"
                              }
                            >
                              FII
                            </button>
                            <button
                              onClick={(event) => handleparamone(event, 4)}
                              className={
                                paramone === 4
                                  ? "btn btn-success"
                                  : "btn btn-secondary"
                              }
                            >
                              DII
                            </button>
                            <button
                              onClick={(event) => handleparamtwo(event, 1)}
                              className={
                                paramtwo === 1
                                  ? "btn btn-success"
                                  : "btn btn-secondary"
                              }
                            >
                              Daily
                            </button>
                            <button
                              onClick={(event) => handleparamtwo(event, 2)}
                              className={
                                paramtwo === 2
                                  ? "btn btn-success"
                                  : "btn btn-secondary"
                              }
                            >
                              Monthly
                            </button>
                          </div>
                          <div className="col-md-6 text-right"></div>
                        </div>

                        <div className="pl-2 pr-2 pb-4 mb-4 ">
                          {getRec ? (
                            <>
                              <table className="table table-bordered">
                                <thead>
                                  <tr className="header-row changefont">
                                    <th className="indexname" size="3">
                                      Date
                                    </th>
                                    <th className="ltp" size="3">
                                      Volumes(Cr.)
                                    </th>
                                    <th className="signal" size="3">
                                      Nifty(%CH)
                                    </th>
                                    <th className="change" size="3">
                                      BNifty(%CHG)
                                    </th>
                                  </tr>
                                </thead>
                                <tbody>
                                  {getRec.map((item) => (
                                    <tr key={temp++}>
                                      <td>{item.sdate} </td>
                                      <td style={{ color: item.vcolor }}>
                                        {item.columnValues}{" "}
                                      </td>
                                      <td style={{ color: item.color }}>
                                        {item.chg}
                                      </td>
                                      <td style={{ color: item.bcolor }}>
                                        {item.bchg}
                                      </td>
                                    </tr>
                                  ))}
                                </tbody>
                              </table>
                            </>
                          ) : (
                            ""
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <FIIDIIFaqs />
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
